import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-internal-type',
  templateUrl: './internal-type.component.html',
  styleUrls: ['./internal-type.component.sass']
})
export class InternalTypeComponent implements OnInit {

  // searchStr: string = '';

  constructor() { }

  ngOnInit() {
  }

  searchByName() {

  }

}
